
define('text!views/logout.html',[],function () { return '<div>\r\n    <div class="overlay" data-bind="visible: isOverlay">\r\n    </div>\r\n</div>';});

